import { cn } from '@eo/shared';

import { ROLE_DOT_CLASS } from './constants';
import { formatHours } from './helpers';
import type { LoggedBreakdownProps } from './types';

// The bar already says which bucket it is, so its breakdown leaves the name out.
export function LoggedBreakdown({ byCfo, byData, logged, budget }: LoggedBreakdownProps) {
  const over = logged - budget;
  return (
    <div className="flex min-w-40 flex-col gap-1.5 tabular-nums">
      <ul className="flex flex-col gap-1">
        {[
          { label: 'CFO', hours: byCfo, dot: ROLE_DOT_CLASS.cfo },
          { label: 'Data team', hours: byData, dot: ROLE_DOT_CLASS.dataTeam },
        ].map((line) => (
          <li key={line.label} className="flex items-center justify-between gap-4">
            <span className="flex items-center gap-1.5">
              <span className={cn('size-2 rounded-full', line.dot)} />
              {line.label}
            </span>
            {formatHours(line.hours)}
          </li>
        ))}
      </ul>
      <span className="border-t border-current/20 pt-1.5">
        {formatHours(logged)} of {formatHours(budget)} logged
      </span>
      {over > 0 && <span>{formatHours(over)} over</span>}
    </div>
  );
}
